import UAParser from 'ua-parser-js';

export class UAInfo {
  constructor() {
    const raw_ua = window.navigator.userAgent.toLowerCase();
    this._UA = (new UAParser()).getResult();;
    this._IPAD_SPECIAL = raw_ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  }

  get UA() {
    return this._UA;
  }

  setTabletViewport(width = '1040') {
    if (this._UA.device.type === 'tablet' || this._IPAD_SPECIAL) {
      document.querySelector("meta[name='viewport']").setAttribute('content', 'width=' + width);
    }
  };

  setDeviceClass() {
    if (this._UA.device.type === 'tablet' || this._IPAD_SPECIAL) {
      document.body.classList.add('ua_tablet');
    } else if (this._UA.device.type === 'mobile') {
      document.body.classList.add('ua_sp');
    } else if (this._UA.device.type === undefined) {
      document.body.classList.add('ua_pc');
    }
  };
  setBrowserClass() {
    if (this._UA.browser.name === 'IE') {
      document.body.classList.add('ua_ie');
    }
  }
  setOsClass() {
    if (this._UA.os.name.startsWith('Windows')) {
      document.body.classList.add('ua_windows');
    }
  }
}

export class BasicTransition {
  static fadeIn(el, speed_ms) {
    el.style.transition = `opacity ${speed_ms}ms`;
    el.style.opacity = '1';
  }
  static fadeOut(el, speed_ms) {
    el.style.transition = `opacity ${speed_ms}ms`;
    el.style.opacity = '0';
  }
}

export class BasicTools{
  static swapAttr(swapOpt) {
    Object.keys(swapOpt).forEach((key) => {
      const items = document.querySelectorAll(`[${key}]`);
      Array.from(items).forEach((item) => {
        item.setAttribute(swapOpt[key], item.getAttribute(key));
        item.removeAttribute(key);
      });
    });
  }
  static getSearchParams() {
    const paramsArray = location.search.substring(1).split('&').map((p) => {
      const param = p.split('=');
      return {[param[0]]: param[1]}
    });
    return Object.assign(...paramsArray);
  }
}

export class EventActions {
  static setCoverAdjust(cover_class) {
    $(cover_class).height($(window).height());

    window.addEventListener('resize', () => {
      $(cover_class).height($(window).height());
    });
  }
  static setMediaQueryAction(media_query) {
    let mql = window.matchMedia(media_query);
    mql.addListener((e) => {
      location.reload(false);
    });
  }
}

export class ScrollActions {
  static setFixedHorizontalScroll(target, actionSelector) {
    $(window).on("scroll", function(){
      $(`${target}${actionSelector}`).css("left", -$(window).scrollLeft());
      $(`${target}:not(${actionSelector})`).css("left", 0);
    });
  
  }
  static setScrollButtonFade(btn_class) {
    let btn_elm = document.querySelector(btn_class);
    if (btn_elm !== null) {
      btn_elm.style.opacity = '0';
      document.addEventListener('scroll', () => {
        if (window.pageYOffset > document.documentElement.clientHeight / 2) {
          BasicTransition.fadeIn(btn_elm, 1000);
        } else {
          BasicTransition.fadeOut(btn_elm, 1000);
        }
      });
    }
  }
  static setScrollActionOffset(target, actionClass = 'action', offset = 0) {
    const items = document.querySelectorAll(`${target}`);
    Array.from(items).forEach((item) => {
      const item_top = $(item).offset().top - offset;
      document.addEventListener('scroll', () => {
        if(window.pageYOffset < item_top){
          item.classList.remove(actionClass);
        }else{
          item.classList.add(actionClass);
        }
      });
    });
  }
  static setScrollActionTiming(target, actionClass = 'action', timing = 0) {
    const items = document.querySelectorAll(`${target}`);
    Array.from(items).forEach((item) => {
      document.addEventListener('scroll', () => {
        if(window.pageYOffset < timing){
          item.classList.remove(actionClass);
        }else{
          item.classList.add(actionClass);
        }
      });
    });
  }
  static setScrollActionCallBack(target, callback, offset = 0, once = false){
    const items = document.querySelectorAll(`${target}`);
    Array.from(items).forEach((item) => {
      let before = true;

      document.addEventListener('scroll', () => {
        const fire_start = $(item).offset().top - offset;
        const fire_end = $(item).offset().top + offset;
        const inRange = fire_start < window.pageYOffset && fire_end > window.pageYOffset;
        if(before && inRange){
          before = false;
          callback();
        }else if(!inRange && !once){
          before = true;
        }
      });
    });
  }
}

export class ClickActions {
  static setSmoothScroll(speed_ms = 500, offset = 0) {
    let links = document.querySelectorAll('a[href*="#"]');
    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener('click', (e) => {
        let href = e.currentTarget.getAttribute('href');
        let target = document.getElementById(href.replace('#', ''));
        let position = $(target).offset().top + offset;
        $("html, body").animate({ scrollTop: position }, speed_ms, "swing");
        return false;
      });
    }
  }

  static setMenuActivate(baseTarget, activateTargets){
    const items = document.querySelectorAll(baseTarget);
    Array.from(items).forEach((item) => {
      for(let i = 0; i < activateTargets.length; i++){
        item.addEventListener('click', () => {
          if(item.classList.contains('active')){
            item.classList.remove('active');
            document.querySelector(activateTargets[i]).classList.remove('active');
          }else{
            item.classList.add('active');
            document.querySelector(activateTargets[i]).classList.add('active');
          }
        });
      }
    });
  }
  static setMenuActivateNth(baseTarget, activateTarget){
    const tabs = document.querySelectorAll(baseTarget);
    Array.from(tabs).forEach((tab) => {
      tab.addEventListener('click', () => {
        document.querySelector(`${baseTarget}.active`).classList.remove('active');
        tab.classList.add('active');
  
        const n = Array.from(tabs).findIndex(t => t === tab);
        document.querySelector(`${activateTarget}.active`).classList.remove('active');
        document.querySelector(`${activateTarget}:nth-child(${n + 1})`).classList.add('active');
      });
    });
  
  }
  static setToggleDtDd(parent) {
    const targets = document.querySelectorAll(parent);
    Array.from(targets).forEach((target) => {
      const dts = target.querySelectorAll('dt');
      Array.from(dts).forEach((tab, tab_i) => {
        tab.addEventListener('click', () => {
          if(tab.classList.contains('active')){
            tab.classList.remove('active');
            tab.nextElementSibling.classList.remove('active');
            $(tab.nextElementSibling).slideUp();
          }else{
            tab.classList.add('active');
            tab.nextElementSibling.classList.add('active');
            $(tab.nextElementSibling).slideDown();
          }
        });
      });
    });
  }
  static setMoreContents(moreSelector, targetSelector, hideClass) {
    const more = document.querySelector(moreSelector);
    more.addEventListener('click', () => {
      const hides = document.querySelectorAll(`${targetSelector}.${hideClass}`);
      Array.from(hides).forEach((hide) => {
        hide.classList.remove(hideClass);
      });
      more.style.display = 'none';
    });
  
  }
}

export class UlTab {
  static setSwitchEventUlLi(tab_ul, data_ul) {
    const tablist = document.querySelectorAll(`${tab_ul}>li`);
    Array.from(tablist).forEach((tab, tab_i) => {
      tab.addEventListener('click', () => {
        document.querySelector(`${tab_ul} .active`).classList.remove('active');
        tab.classList.add('active');
        document.querySelector(`${data_ul} .active`).classList.remove('active');
        document.querySelector(`${data_ul}>li:nth-child(${tab_i + 1})`).classList.add('active');
      });
    });
  }

  static setSwitchEventDivId(tab_ul, data_class) {
    const tablist = document.querySelectorAll(`${tab_ul}>li`);
    Array.from(tablist).forEach((tab, tab_i) => {
      tab.addEventListener('click', () => {
        const key = tab.className.split(' ').filter(c => c !== 'active');
        const div = document.querySelector(`#${key[0]}`);
        if(!div || key.length === 0){
          return;
        }

        document.querySelector(`${tab_ul} .active`).classList.remove('active');
        tab.classList.add('active');

        const datas = document.querySelectorAll(data_class);
        Array.from(datas).forEach((data) => {
          data.classList.remove('active');
        });

        div.classList.add('active');
      });
    });
  }

}
